import { useRef, useState } from "react";
import { useEffect } from "react";
import $, {  } from 'jquery';
import { useParameter, useProperty } from "./general";
import { redoChange, undoChange } from "../app/storage/changes_admin";
// label_css {
//   color: #727272;
//   font-size: 14px;
//   margin-bottom: 4px;
// }

// textarea {
//   background: #ffffff;
//   border-radius: 0;
//   border: none;
//   border-bottom: 1px solid #ededed;
//   font-size: 14px;
//   line-height: 1.5;
//   padding: 8px 0;
//   resize: none;
//   transition: border-color 150ms ease;
//   width: 100%;
// }

// textarea:hover {
//   border-color: #c6c6c6;
// }

// // Updates the height of a <textarea> when the value changes.
// function useAutosizeTextArea (
//   textAreaRef,
//   value
// ) {
//   useEffect(() => {
//     if (textAreaRef) {
//       // We need to reset the height momentarily to get the correct scrollHeight for the textarea
//       textAreaRef.style.height = "0px";
//       const scrollHeight = textAreaRef.scrollHeight;

//       // We then set the height directly, outside of the render loop
//       // Trying to set this with state or a ref will product an incorrect value.
//       textAreaRef.style.height = scrollHeight + "px";
//     }
//   }, [textAreaRef, value]);
// };


export function AutosizeTextArea({scriptId,fontSize,subscriptId,initial,onChange,style,className}) {

  initial = initial?initial:"";
  
  const [getValue, setValue] = useParameter(initial);
  const [getWidth, setWidth] = useProperty(0);

  const textAreaRef = useRef(null);
  const widthHandlerRef = useRef(null);

  function onWidthChange(e){
    setWidth($(textAreaRef.current).width());
  }

  useEffect(() => {
    if (!widthHandlerRef.current && textAreaRef.current){

      var ro = new ResizeObserver(onWidthChange)
      widthHandlerRef.current = onWidthChange;
      ro.observe(textAreaRef.current);
      //$(textAreaRef.current).on('resize',onWidthChange)
    }
    redoHeight();
  }, [textAreaRef.current, getValue(), getWidth()]);

  function redoHeight(){
    if (textAreaRef.current) {
      // We need to reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.current.style.height = "0px";
      const scrollHeight = textAreaRef.current.scrollHeight;

      // We then set the height directly, outside of the render loop
      // Trying to set this with state or a ref will product an incorrect value.
      textAreaRef.current.style.height = scrollHeight + "px";
    }
  }
  
  const handleChange = (evt) => {
    const val = evt.target.value;
    setValue(val);
    if (onChange){
        onChange(val);
    }
  };

  fontSize = fontSize?fontSize+"em":'14px'

  style = $.extend({
        overflow:'hidden',
        background: '#ffffff',
        borderRadius: 0,
        border: 'none',
        borderBottom: '1px solid #ededed',
        fontSize: fontSize,
        lineHeight: 1.5,
        padding: '0',
        margin : '0',
        resize: 'none',
        transition: 'border-color 150ms ease',
        width: '100%',
        display : 'block',
  },style);

  className = className+ " " + "";

  function onKeyDown(e){
    if (e.ctrlKey && e.key=='z'){
      undoChange(scriptId,subscriptId);
      e.preventDefault();
    } else if (e.ctrlKey && e.key=='y'){
      redoChange();
      e.preventDefault();
    }
  }
  return (
      <textarea
        id="review-text"
        onChange={handleChange}
        ref={textAreaRef}
        rows={1}
        value={getValue()}
        className = {className}
        style = {style}
        onKeyDown={onKeyDown}
      />
  );

}
